import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset scroll to the top of the window on every route change.
 * Mount once near the root of the React Router tree (inside <Router> but
 * outside <Routes>). Without this, React Router preserves the previous
 * scroll offset which is jarring on long pages (education articles).
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        // `instant` keeps the jump invisible — no half-second animation that
        // makes the page feel sluggish.
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}
